import React from 'react';
import WeddingDetails from '../components/WeddingDetails/WeddingDetails';

const DetailsPage: React.FC = () => {
  return (
    <main className="page">
      <WeddingDetails />
    </main>
  );
};

export default DetailsPage; 